import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/icons/jb-phone-icon/jb-phone-icon.scss?inline
var jb_phone_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: inline-block;
  height: var(--icon-size, 18px);
  width: var(--icon-size, 18px);
}`;

// src/components/icons/jb-phone-icon/jb-phone-icon.ts
var JbPhoneIcon = class extends h {
  render() {
    return ke`
      <svg
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Phone">
          <path
            id="Vector 6"
            d="M5.38493 12.5923L5.8067 12.1655L5.79651 12.1554L5.78586 12.1459L5.38493 12.5923ZM16.1905 12.5923H16.7905C16.7905 12.3786 16.6769 12.1811 16.4922 12.0737L16.1905 12.5923ZM12.3991 10.386L12.7008 9.86739C12.4558 9.72479 12.1444 9.77318 11.9542 9.98341L12.3991 10.386ZM10.3188 12.685L10.0288 13.2103C10.2726 13.3449 10.5769 13.2941 10.7637 13.0876L10.3188 12.685ZM5.23788 7.18119L4.8024 6.76844C4.6387 6.94116 4.59255 7.19429 4.68475 7.41366L5.23788 7.18119ZM7.27873 5.02788L7.71422 5.44062C7.88958 5.2556 7.92888 4.97997 7.81222 4.75331L7.27873 5.02788ZM5.23788 1.0625L5.77137 0.78793C5.66537 0.581983 5.45031 0.455438 5.2188 0.462803L5.23788 1.0625ZM16.4922 12.0737L12.7008 9.86739L12.0973 10.9046L15.8887 13.1108L16.4922 12.0737ZM11.9542 9.98341L9.8739 12.2825L10.7637 13.0876L12.844 10.7885L11.9542 9.98341ZM10.6088 12.1598C8.93312 11.2347 8.04467 10.6211 7.41943 9.91973C6.79603 9.22045 6.39963 8.39679 5.79101 6.94871L4.68475 7.41366C5.28929 8.85204 5.75107 9.8516 6.5237 10.7183C7.29449 11.5829 8.33993 12.278 10.0288 13.2103L10.6088 12.1598ZM5.67336 7.59393L7.71422 5.44062L6.84325 4.61514L4.8024 6.76844L5.67336 7.59393ZM7.81222 4.75331L5.77137 0.78793L4.70439 1.33707L6.74524 5.30245L7.81222 4.75331ZM5.2188 0.462803C3.71473 0.510653 2.61748 1.11135 1.95277 2.11125C1.30796 3.08123 1.12612 4.34276 1.24261 5.63191C1.47511 8.20497 2.92062 11.1854 4.98401 13.0386L5.78586 12.1459C3.94979 10.4968 2.64319 7.79754 2.43774 5.52392C2.33525 4.38973 2.51297 3.43615 2.95211 2.77557C3.37136 2.1449 4.08244 1.69956 5.25696 1.6622L5.2188 0.462803ZM4.96317 13.019C7.3611 15.389 10.2049 16.6499 12.5227 16.6624C13.6866 16.6687 14.7609 16.3579 15.5519 15.6568C16.3536 14.9462 16.7905 13.8998 16.7905 12.5923H15.5905C15.5905 13.621 15.256 14.3155 14.7559 14.7587C14.2451 15.2115 13.4872 15.4676 12.5291 15.4624C10.6029 15.452 8.04395 14.3766 5.8067 12.1655L4.96317 13.019Z"
            fill="currentColor"
          />
        </g>
      </svg>
    `;
  }
};
JbPhoneIcon.styles = r(jb_phone_icon_default);
JbPhoneIcon = __decorateClass([
  customElement("jb-phone-icon")
], JbPhoneIcon);

export {
  JbPhoneIcon
};
